import { SinglePaymentMethod } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredEnum, requiredString } from '@/utils/zodUtils';
export const AddAgentInSinglePaymentProviderContextCredentialsFormSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      providerId: requiredString(t),
      paymentMethodType: requiredEnum(SinglePaymentMethod, t),
      configuration: z.boolean().nullable().optional(),
      productId: z.string().nullable().optional(),
      merchantId: z.string().nullable().optional(),
      merchantKey: z.string().nullable().optional(),
      merchantPassword: z.string().nullable().optional(),
    })
    .refine((data) => !(data.configuration && !data.productId), {
      message: t('REQUIRED_FIELD'),
      path: ['productId'],
    })
    .refine((data) => !(data.configuration && !data.merchantId), {
      message: t('REQUIRED_FIELD'),
      path: ['merchantId'],
    })
    .refine((data) => !(data.configuration && !data.merchantKey), {
      message: t('REQUIRED_FIELD'),
      path: ['merchantKey'],
    })
    .refine((data) => !(data.configuration && !data.merchantPassword), {
      message: t('REQUIRED_FIELD'),
      path: ['merchantPassword'],
    });
export type AddAgentInSinglePaymentProviderContextCredentialsFormType = z.infer<
  ReturnType<typeof AddAgentInSinglePaymentProviderContextCredentialsFormSchema>
>;
